import React, { useContext } from 'react'
import { Context } from '../../../Context';
import { CalligraphicExercisesReportDetailRequestView } from '../../views/index'
import { SignatureRequestService, SignerService, UserDocService, LocalStorageService, SignatureTypesService, UserDocSuppService, RequestSignatureReplicationService } from '../../../services/index'
import { SignatureRequestValidator } from '../../../validators/index'
import { useTranslation } from "react-i18next"
import 'moment/locale/es'

class RequestDetailAction extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      requestId: '',
      tokenUserName: '',
      tokenUserNames: '',
      emailUser: '',
      tokenUserLastnames: '',
      userInfo: null,
      loading: true,
      file: null,
      isInvolved: false,
      message: '',
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false
    }
  }

  token = {}
  url = process.env.REACT_APP_MIFIRMA_API
  signatureRequestService = new SignatureRequestService(this.url)
  signerService = new SignerService(this.url)
  signatureTypesService = new SignatureTypesService(this.url)
  userDocService = new UserDocService(this.url)
  requestSignatureReplicationService = new RequestSignatureReplicationService(this.url)
  localStorageService = new LocalStorageService()
  validator = SignatureRequestValidator(this.props.t)
  userDocSuppService = new UserDocSuppService(this.url)


  async componentDidMount() {
    this.setState({ loading: true })
    let requestId = this.props.match.params.id
    let token = this.localStorageService.getLocalStorageItem('token').idToken
    this.token = token
    let userInfo = this.localStorageService.getLocalStorageItem('user').userMetaData
    let tokenUserName = `${userInfo.userA3Cloud.firstName} ${userInfo.userA3Cloud.firstLastName} ${userInfo.userA3Cloud.secondLastName}`
    let tokenUserNames = `${userInfo.userA3Cloud.firstName}`
    let emailUser = `${userInfo.userA3Cloud.email}`
    let tokenUserLastnames = `${userInfo.userA3Cloud.firstLastName} ${userInfo.userA3Cloud.secondLastName}`
    let requestExist = await this.requestSignatureReplicationService.getRequestDocumentInformation(token, requestId)
    // Only if the request is complete
    let file = null
    if (requestExist?.data && requestExist.data.requestStatusId === 3) {
      let resquestPdf = await this.requestSignatureReplicationService.getRequestDocumentDownload(token, requestId)
      file = resquestPdf.data.validationDocumentPdf
    }

    let data = {}
    let imgs = await this.userDocSuppService.getUserDocSupps(token)
    if (imgs) {
      let { autographySignImg, ineFrontImg, ineBackImg } = imgs
      data = {
        signatureImg: 'data:image/png;base64,' + autographySignImg,
        ineFrontImg: 'data:image/png;base64,' + ineFrontImg,
        ineBackImg: 'data:image/png;base64,' + ineBackImg
      }
    }

    let isInvolved = false
    if (requestExist?.data?.involveds) {
      let curretMail = requestExist?.data?.involveds.find(i => i.email === emailUser)
      isInvolved = !!curretMail
    }
    this.setState({
      requestId,
      tokenUserName,
      tokenUserNames,
      emailUser,
      tokenUserLastnames,
      userInfo,
      loading: false,
      file,
      isInvolved,
      requestTypeId: (requestExist?.data.requestTypeId) ? Number(requestExist.data.requestTypeId) : 0,
      isUserDocSuppService: data?.signatureImg && data?.ineFrontImg && data?.ineBackImg
    })
  }

  /**
  * @author Alan Aguilar
  * @description Function to show or hide the LoadingRequesting Dialog
  * @updatedDate 10-12-2021
  * @param {Boolean} value
  * @memberof RequestDetailAction
  */
  toggleLoadingRequesting = (value) => {
    this.setState({ showLoadingRequesting: value })
  }

  /**
  * @author Alan Aguilar
  * @description Function to show or hide the CompletedRequesting Dialog
  * @updatedDate 10-12-2021
  * @param {Boolean} value
  * @param {Boolean} redirect
  * @memberof RequestDetailAction
  */
  toggleCompletedRequesting = (value, redirect) => {
    this.setState({
      showCompletedRequesting: value
    }, () => {
      setTimeout(() => {
        this.setState({ showCompletedRequesting: false })
        if (redirect === true) this.props.history.push('/')
      }, 2000)
    })
  }

  /**
  * @author Alan Aguilar
  * @description Function to show or hide the ErrorRequesting Dialog
  * @updatedDate 10-12-2021
  * @param {Boolean} value
  * @memberof RequestDetailAction
  */
  toggleErrorRequesting = (value) => {
    this.setState({
      showErrorRequesting: value
    }, () => {
      setTimeout(() => {
        this.setState({ showErrorRequesting: false })
      }, 6000)
    })
  }

  /**
  * @author Alan Aguilar
  * @description Function to submit the information to create sginature replication report
  * @updatedDate 10-12-2021
  * @param {Object} formRequestData
  * @memberof RequestDetailAction
  */
  onSubmitReplicationReport = async (formRequestData) => {
    let backendStatusCode = 0
    try {
      await this.toggleLoadingRequesting(true)

      let result = await this.requestSignatureReplicationService.postRequestSignatureReplicationReport(this.token, formRequestData)
      if (!result.statusCode === 200 || result.statusCode === -1) {
        backendStatusCode = Number(result.statusCode)
        throw new Error()
      }

      await this.toggleLoadingRequesting(false)
      await this.toggleCompletedRequesting(true, true)
      return true
    } catch (error) {
      switch (backendStatusCode) {
        case 403:
          this.setState({ message: `${this.props.t('requestDetailAction.messageErrorUnauthorized')}` })
          break
        case -420:
          this.setState({ message: `${this.props.t('requestDetailAction.messageErrorRequestProcesed')}` })
          break
        case -2:
          this.setState({ message: `${this.props.t('requestDetailAction.messageErrorRequestAlreadyProcessed')}` })
          break
        case -3:
          this.setState({ message: `${this.props.t('requestDetailAction.messageErrorNotAuthorizeForThisReport')}` })
          break
        case -4:
          this.setState({ message: `${this.props.t('requestDetailAction.messageErrorINEnotFound')}` })
          break
        default:
          this.setState({ message: `${this.props.t('requestDetailAction.messageErrorDefault')}` })
      }
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  /**
  * @author Alan Aguilar
  * @description Function to submit the information to create sginature replication report
  * @updatedDate 10-12-2021
  * @param {Object} formRequestData
  * @memberof RequestDetailAction
  */
  onSendReport = async (requestIdData) => {
    let backendStatusCode = 0
    try {
      await this.toggleLoadingRequesting(true)

      let result = await this.requestSignatureReplicationService.postSendPdfRequestSignatureReplicationReport(this.token, requestIdData)
      if (!result.statusCode === 200) {
        backendStatusCode = Number(result.statusCode)
        throw new Error()
      }

      await this.toggleLoadingRequesting(false)
      await this.toggleCompletedRequesting(true, true)
      return true
    } catch (error) {
      switch (backendStatusCode) {
        case 403:
          this.setState({ message: `${this.props.t('requestDetailAction.messageErrorUnauthorized')}` })
          break
        case -420:
          this.setState({ message: `${this.props.t('requestDetailAction.messageErrorRequestProcesed')}` })
          break
        case -2:
          this.setState({ message: `${this.props.t('requestDetailAction.messageErrorRequestAlreadyProcessed')}` })
          break
        default:
          this.setState({ message: `${this.props.t('requestDetailAction.messageErrorDefault')}` })
      }
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  onErrorTimeStamp = async () => {
    this.setState({ message: `${this.props.t('signatureRequestDetailAction2.errorStampTimeFails')}` })
    this.toggleErrorRequesting(true)
    return false
  }

  render() {
    return (<CalligraphicExercisesReportDetailRequestView
      {...this.state}
      token={this.token}
      onSubmitReplicationReport={this.onSubmitReplicationReport}
      onSendReport={this.onSendReport}
      requestSignatureReplicationService={this.requestSignatureReplicationService}
      toggleLoadingRequesting={this.toggleLoadingRequesting}
      toggleCompletedRequesting={this.toggleCompletedRequesting}
      toggleErrorRequesting={this.toggleErrorRequesting}
      onErrorTimeStamp={this.onErrorTimeStamp}
    />)
  }
}

function RequestDetailActionContainer(props) {
  const { t } = useTranslation()
  const { setShowError } = useContext(Context);
  return (
    <RequestDetailAction
      {...props}
      t={t}
      setShowError={setShowError}

    />
  )
}



export { RequestDetailActionContainer as default }
